import { defineMessages } from 'react-intl';

export const messages: {
	blogPostTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	pageTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	whiteboardTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	blogPostTitle: {
		id: 'confluence.page.preview.panel.blogPostTitle',
		defaultMessage: 'Confluence Blog Post',
		description: 'Title shown in the preview panel when viewing a Confluence blog post.',
	},
	pageTitle: {
		id: 'confluence.page.preview.panel.pageTitle',
		defaultMessage: 'Confluence Page',
		description: 'Page title shown in the preview panel when viewing a Confluence page.',
	},
	whiteboardTitle: {
		id: 'confluence.page.preview.panel.whiteboardTitle',
		defaultMessage: 'Confluence Whiteboard',
		description: 'Page title shown in the preview panel when viewing a Confluence whiteboard.',
	},
});
